document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('template--product-sve-boje-bundles')) return;

  const baseUrl = 'https://cdn.shopify.com/s/files/1/0937/4200/6645/files/';
  
  const colorMap = {
    'Pink': ['samo_proizvod.png', 'bundle_2.png', 'bundle_3.png'],
    'Blau': ['samo_proizvod_plavi.png', 'bundle_2_plavi.png', 'bundle_3_plavi.png'],
    'Grün': ['samo_proizvod_zeleni.png', 'bundle_2_zeleni.png', 'bundle_3_zeleni.png'],
    'Lila': ['samo_proizvod_ljubicasti.png', 'bundle_2_ljubicasti.png', 'bundle_3_ljubicasti.png']
  };

  let currentColor = 'Pink';

  function updateBundleImages() {
    const images = colorMap[currentColor];
    if (!images) return;
    const bundleImages = document.querySelectorAll('.quantity-break__image img');
    bundleImages.forEach(function(img, index) {
      if (images[index]) {
        img.src = baseUrl + images[index];
        img.srcset = '';
      }
    });
  }

  document.querySelectorAll('input[name="Farbe"]').forEach(function(input) {
    input.addEventListener('change', function() {
      currentColor = this.value;
      setTimeout(updateBundleImages, 350);
    });
  });

  document.addEventListener('click', function(e) {
    const bundleBtn = e.target.closest('.quantity-break__option, .quantity-break, [class*="quantity-break"]');
    if (bundleBtn) {
      setTimeout(updateBundleImages, 350);
    }
  });
});